import ModalWithButtons from './modal_with_buttons';

export default ModalWithButtons;
